import { Record, List } from 'immutable';

export const MediaSectionSize = Record({ id: '', name: '' }, 'MediaSectionSize');

export const LARGE = new MediaSectionSize({ id: 'Large', name: 'Large' });
export const MEDIUM = new MediaSectionSize({ id: 'Medium', name: 'Medium' });
export const SMALL = new MediaSectionSize({ id: 'Small', name: 'Small' });

// Only these are allowed for Media sections, they reflect state on the server
export const MEDIA_SECTION_SIZES = List([LARGE, MEDIUM, SMALL]);

// MediaSizes are commonly used image dimensions on the site.
// Sizes should be specified in 1x.
export class MediaSize extends Record({
  height: '',
  width: '',
}, 'MediaSize') {}

// Common image sizes.
export const FULL_SIZE = new MediaSize({ width: '100%', height: '100%' });
export const LESSON_VIEW_LARGE = new MediaSize({ height: '384px' });
export const LESSON_VIEW_MEDIUM = new MediaSize({ height: '256px' });
export const LESSON_VIEW_SMALL = new MediaSize({ height: '128px' });
export const SENTENCE = new MediaSize({ width: '48px', height: '48px' });
export const LESSON_DIALOG_SPEAKER = new MediaSize({ width: '60px', height: '60px' });
export const LESSON_DIALOG_SPEAKER_SMALL = new MediaSize({ width: '40px', height: '40px' });
export const EDITOR_PREVIEW = new MediaSize({ width: '96px', height: '64px' });
export const DAILY_NEWS_LESSON_INFO = new MediaSize({ width: '55px', height: '55px' });
export const LESSON_HEADER = new MediaSize({ width: '232px', height: '174px' });
export const LESSON_HEADER_SMALL = new MediaSize({ width: '200px', height: '150px' });

// Chat images
export const CHAT_IMAGE = new MediaSize({ width: '300px', height: '440px' });
export const CHAT_IMAGE_MINUMUM = new MediaSize({ width: '100px', height: '100px' });

// Thumbnails
export const THUMBNAIL_LARGE = new MediaSize({ height: '100px', width: '100px' });
export const THUMBNAIL_SMALL = new MediaSize({ height: '60px', width: '60px' });

// Teacher Recruitment
export const ID_IMAGE_PREVIEW = new MediaSize({ width: '200px', height: '300px' });
